// Production "Lesson X of Y" chip + Previous/Next lesson navigation.
//
// Reads window.OOLearningHubLessonPositionData (generated by
// shopify/scripts/generate-preview-fixture.js from the public-launch-scoped,
// lesson_id-ordered category sequence -- see that file for how the ordering
// is derived). This is a category-relative position among currently public
// lessons, never a completion/progress indicator, and never a link to a
// DRAFT lesson: any handle missing from the generated data (not on the
// public launch list) simply has no entry here, so nothing renders for it.
(function () {
  function addPositionChip(article, position) {
    var meta = article.querySelector('.learning-meta');
    if (!meta || meta.querySelector('[data-lesson-position-chip]')) return;

    var chip = document.createElement('span');
    chip.className = 'learning-meta__item';
    chip.setAttribute('data-lesson-position-chip', '');
    chip.textContent = 'Lesson ' + position.index + ' of ' + position.total;
    meta.appendChild(chip);
  }

  function buildSequenceCard(direction, entry) {
    var card = document.createElement('a');
    card.className = 'learning-lesson-nav-card learning-lesson-nav-card--' + direction;
    card.href = '/pages/learn/' + entry.handle;

    var label = document.createElement('span');
    label.className = 'learning-lesson-nav-card__label';
    label.textContent = direction === 'previous' ? '← Previous lesson' : 'Next lesson →';
    card.appendChild(label);

    var title = document.createElement('span');
    title.className = 'learning-lesson-nav-card__title';
    title.textContent = entry.title;
    card.appendChild(title);

    var position = document.createElement('span');
    position.className = 'learning-lesson-nav-card__position';
    position.textContent = 'Lesson ' + entry.index + ' of ' + entry.total;
    card.appendChild(position);

    return card;
  }

  function renderSequenceNav(shell, position) {
    if (!position.previous && !position.next) {
      shell.remove();
      return;
    }

    var container = shell.querySelector('.page-width') || shell;

    var nav = document.createElement('nav');
    nav.className = 'learning-lesson-nav';
    if (!position.previous || !position.next) {
      nav.classList.add('learning-lesson-nav--single');
    }
    nav.setAttribute('aria-label', 'Previous and next lesson');

    if (position.previous) {
      nav.appendChild(
        buildSequenceCard('previous', {
          handle: position.previous.handle,
          title: position.previous.title,
          index: position.previous.index,
          total: position.total
        })
      );
    }

    if (position.next) {
      nav.appendChild(
        buildSequenceCard('next', {
          handle: position.next.handle,
          title: position.next.title,
          index: position.next.index,
          total: position.total
        })
      );
    }

    container.appendChild(nav);
    shell.hidden = false;
  }

  function init() {
    var data = window.OOLearningHubLessonPositionData || {};
    var articles = document.querySelectorAll('.learning-lesson[data-lesson-handle]');

    Array.prototype.forEach.call(articles, function (article) {
      var handle = article.getAttribute('data-lesson-handle') || '';
      var position = data[handle];

      var shell = article.querySelector('[data-lesson-sequence]');

      if (!position) {
        if (shell) shell.remove();
        return;
      }

      addPositionChip(article, position);
      if (shell) renderSequenceNav(shell, position);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
